import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setTitle } from '../../redux/title/action';
import { TextSmall } from '../../components/text';
import {
  InfoHeaderStyledContainer,
  RegisterStyledContainer,
} from '../../components/container/styles';
import { useGetRegProductList } from './hooks/useGetRegProductList';
import { RenderForm } from '../../components/forms';
import { FORM_PIC, FORM_PRODUCT_DATA, FORM_SHOW_IMAGE_WARRANTY } from './form';
import { ContainerButton } from '../../styles/global-style';
import { ButtonTheme } from '../../components/buttons';

import { Checkbox, Row, Spin, Typography } from 'antd';
import { ROUTES_PATH } from '../../resources/routes-name';
import { styleGapform } from './styles/styles';
import liff from '@line/liff';

export const RegisterProduct = () => {
  const dispatch = useDispatch();
  const [isAccepted, setIsAccepted] = useState(false);
  const queryParams = new URLSearchParams(window.location.search);
  const warrantyNumberCode = queryParams.get('warrantyNumberCode');
  const {
    getValues,
    setValue,
    control,
    mobileBrandList,
    channelBuyList,
    onSubmit,
    handleSubmit,
    isLoadingBarcode,
  } = useGetRegProductList(warrantyNumberCode);


  useEffect(() => {
    dispatch(setTitle('ลงทะเบียนรับประกันสินค้า'));
  }, [dispatch]);

  const registerProductData = useSelector((state) => state.registerProduct);

  // บันทึกลง localStorage เมื่อมีข้อมูล (รองรับทั้งโครงสร้างแบบ item หรือ flat)
  useEffect(() => {
    const hasData =
      registerProductData &&
      (registerProductData.productId ||
        registerProductData.item?.productId ||
        Object.keys(registerProductData).length > 0);
    if (hasData) {
      const toStore = registerProductData.item
        ? { ...registerProductData.item, ...registerProductData, item: undefined, warranty: undefined }
        : registerProductData;
      localStorage.setItem('registerProductData', JSON.stringify(toStore));
    }
  }, [registerProductData]);

  // โหลดข้อมูลลง form จาก Redux (หลัง navigate) หรือจาก localStorage (หลัง refresh)
  useEffect(() => {
    if (!setValue) return;
    // ถ้า Redux มีข้อมูล ให้ใส่ form จาก Redux เลย (กรณีเพิ่ง navigate มา)
    if (registerProductData && Object.keys(registerProductData).length > 0) {
      const flat =
        registerProductData.item != null
          ? { ...registerProductData.item, ...registerProductData }
          : { ...registerProductData };
      delete flat.item;
      delete flat.warranty;
      Object.entries(flat).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          setValue(key, value);
        }
      });
      return;
    }
    // fallback: อ่านจาก localStorage (กรณี refresh หน้า)
    const stored = localStorage.getItem('registerProductData');
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        Object.entries(parsed).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            setValue(key, value);
          }
        });
      } catch (_) {
        // ignore
      }
    }
  }, [setValue, registerProductData]);

  const handlePolicyClick = () => {
    liff.openWindow({
      url: ROUTES_PATH.ROUTE_TERM_WARRANTY.PATH,
      external: true,
    });
  };
  const handleCheckboxChange = (e) => {
    setIsAccepted(e.target.checked);
  };

  return (
    <Spin spinning={isLoadingBarcode}>
      <RegisterStyledContainer>
        <InfoHeaderStyledContainer>
          <TextSmall
            text={<span>กรุณากรอกข้อมูลเพื่อลงทะเบียนรับประกันสินค้า</span>}
            style={{
              color: '#8c6e19',
            }}
            bold
          />
        </InfoHeaderStyledContainer>
        <div style={{ padding: '30px', paddingBottom: '70px' }}>
          <RenderForm
            control={control}
            getValues={getValues}
            setValue={setValue}
            forms={FORM_PRODUCT_DATA({ mobileBrandList, channelBuyList })}
          />
          <div style={styleGapform}>
            <RenderForm
              control={control}
              getValues={getValues}
              setValue={setValue}
              forms={FORM_SHOW_IMAGE_WARRANTY()}
            />
            <RenderForm
              control={control}
              getValues={getValues}
              setValue={setValue}
              forms={FORM_PIC()}
            />
          </div>
          <div
            style={{
              ...styleGapform,
              marginTop: 10,
              gap: '16px',
            }}
          >
            <Checkbox checked={isAccepted} onChange={handleCheckboxChange}>
              <span style={{ color: 'inherit' }}>ฉันได้ยอมรับ</span>
            </Checkbox>
            <Row justify="center">
              <Typography.Link onClick={() => handlePolicyClick()} underline>
                ข้อตกลงการรับประกันสินค้า
              </Typography.Link>
            </Row>
            <ContainerButton center>
              <ButtonTheme
                useFor="CONFIRM_REG"
                disabled={!isAccepted}
                style={{ width: '100%' }}
                onClick={() => {
                  handleSubmit(onSubmit)();
                }}
              />
            </ContainerButton>
          </div>
        </div>
      </RegisterStyledContainer>
    </Spin>
  );
};
